import { Component } from "@angular/core";
import { IconComponent } from "@husbanken/designsystem-angular-core";

@Component({
  selector: "stat-footer",
  templateUrl: "./footer.component.html",
  imports: [IconComponent],
})
export class FooterComponent {}
